
import EDButton from '../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../../../BaseComponents/Icon/EDIcon';
import { makeStyles } from 'tss-react/mui';

interface IProps {
  reset: EkonomiskAnalysExportToolbarResetFnType;
}

export type EkonomiskAnalysExportToolbarResetFnType = () => void;

const useStyles = makeStyles()(() => ({
  container: {
    marginTop: '-12px',
  },
}));

/**
 * Toolbaren för export dialogen för en analys
 */
const EkonomiskAnalysExportToolbar: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();
  return (
    <div className={classes.container}>
      <EDButton
        label="Återställ"
        onClick={props.reset}
        color="inherit"
        icon={<EDIcon color="inherit" iconType="restore" />}
        captionLabel
        labelNotUpperCase
        flat
      />
    </div>
  );
};

export default EkonomiskAnalysExportToolbar;
